/**
 *
 * Asynchronously loads the component for InputSearch
 *
 */

import { loadable } from '../../../utils';

export default loadable(() => import('./index'), {});
